module.exports = __webpack_public_path__ + "media/images/emblems/Luetschental-coat_of_arms-eb85b1f361c3042a0e6b093e05762d1b.svg";